/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Uploads_Change_RefusedInputs */



/**
* | output |
* | --- |
* | "Only the member and the project's admins can change files in this folder." |
*
* @param {Chat_Uploads_Change_RefusedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_uploads_change_refused = /** @type {((inputs?: Chat_Uploads_Change_RefusedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Uploads_Change_RefusedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur das Mitglied und die Administratoren des Projekts können Dateien in diesem Ordner ändern.")
	return /** @type {LocalizedString} */ ("Only the member and the project's admins can change files in this folder.")
});